export const getContent = ({ src, pluginKey, height = 250, width = 250, href }: { src: string, pluginKey: string, height?: number, width?: number, href?: string }) => {

  const shouldWrapInLink = Boolean(href);

  const properties = {
    height,
    width,
    src,
    href,
  };

  // max-width keeps the image inside the email's content column: brands can size an
  // image wider than the column, and email clients would otherwise let it break out.
  const styles = `
    cursor: pointer;
    display: inline-block;
    max-width: 100%;
    text-decoration: none;
  `;

  // aspect-ratio carries the chosen height so it still applies at full width, while
  // height:auto lets the image scale proportionally once max-width shrinks it.
  const imgStyles = `
    aspect-ratio: ${width} / ${height};
    height: auto;
    max-width: 100%;
    width: ${width}px;
  `;

  const anchor = document.createElement('a');
  anchor.setAttribute('style', styles);
  anchor.setAttribute(`data-${pluginKey}`, 'true');
  anchor.dataset.aksProperties = JSON.stringify(properties);
  anchor.setAttribute('contenteditable', 'false');

  if (shouldWrapInLink) {
    anchor.setAttribute('href', href);
    anchor.setAttribute('target', '_blank');
  }

  const img = document.createElement('img');
  img.setAttribute('src', src);
  img.setAttribute(`data-${pluginKey}`, 'true');
  img.setAttribute('style', imgStyles);

  // Blank character required since TinyMCE will automatically remove empty anchor tags
  anchor.appendChild(img);

  return anchor.outerHTML;
};
